import { render, staticRenderFns } from "./DilationTimeStudy.vue?vue&type=template&id=bde034ce&scoped=true&"
import script from "./DilationTimeStudy.vue?vue&type=script&lang=js&"
export * from "./DilationTimeStudy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bde034ce",
  null
  
)

export default component.exports